import { render, staticRenderFns } from "./VekaletBankaHesabiSec.vue?vue&type=template&id=791fed0c"
import script from "./VekaletBankaHesabiSec.vue?vue&type=script&lang=ts"
export * from "./VekaletBankaHesabiSec.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports